<script setup lang="ts">

const emit = defineEmits<{
  (e: 'pageChange', p: number): void
}>()


defineProps<{
  currentPage: number
  totalPages: number
}>()


const changePage = (page: number) => {
  emit('pageChange', page);
}

</script>

<template>
  <div class="flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg" style="margin-bottom: 100px !important;">
    <button
      :disabled="currentPage === 1"
      @click="$emit('pageChange', currentPage - 1)"
      class="px-3 py-1 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50"
    >
      Previous
    </button>
    
    <div class="flex items-center gap-3">
      <span class="text-sm text-gray-700 dark:text-gray-200">
        Page
      </span>

      <!-- Dropdown -->
      <select
        :value="currentPage"
        @change="changePage(Number(($event.target as HTMLSelectElement).value))"
        class="px-2 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <option v-for="page in totalPages" :key="page" :value="page">
          {{ page }}
        </option>
      </select>

      <span class="text-sm text-gray-700 dark:text-gray-200">
        of {{ totalPages }}
      </span>
    </div>
    
    <button
      :disabled="currentPage === totalPages"
      @click="$emit('pageChange', currentPage + 1)"
      class="px-3 py-1 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50"
    >
      Next
    </button>
  </div>
</template>